const dispatch = require("../store.js").dispatch;

const ValidExtensionActions = require("../actions/ValidExtensionActions.js");
const Server = require("../Server.js");

const ValidExtensionActionCreators = {
    Get() {
        dispatch((thunkDispatch) => {
            thunkDispatch({
                type: ValidExtensionActions.Get
            });

            Server.Get("valid-extension")
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    thunkDispatch({
                        type: ValidExtensionActions.Got,
                        Data: json
                    });
                })
                .catch((ex) => {
                    thunkDispatch({
                        type: ValidExtensionActions.GetErrored,
                        Error: ex
                    });
                });
        });
    }
};

module.exports = ValidExtensionActionCreators;


// WEBPACK FOOTER //
// ./src/actionCreators/ValidExtensionActionCreators.js